/**
 * @desc 獲取URL參數-(已知key，獲取值)
 * @param {String} name
 * @returns {String} value
 */
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.slice(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  var context = "";
  if (r != null)
    context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context === null || context === "" || context === "undefined" ? "" : context;
}

/**
 * @desc 是否為平板（width>=750）
 * @param
 * @returns {Boolean}
 */
export const isPad = () => {
  const deviceWidth = document.body.clientWidth;
  if (deviceWidth >= 750) {
    return true;
  }
  return false;
}
